<template>
    <div class="w-full background flex flex-col items-stretch"
        :class="{ 'sm:max-w-72': !three_col, 'sm:max-w-96': three_col }">
        <div class="wow fadeInUp text-left grow flex flex-col justify-between" data-wow-delay=".15s"
            style="visibility: visible; animation-delay: 0.15s">
            <div class="grow m-2 ml-4 h-auto">
                <Badge v-if=category :label=category />
                <Badge v-if="icon" :icon="icon" />
                <div v-if="image_url" class="mb-6 flex justify-center h-[32px] w-[32px]">
                    <img :src="image_url" :class="image_40 ? 'h-24 object-contain' : ''" />
                </div>
                <p class="box-title my-5" v-if="title">
                    {{ title }}
                </p>
                <p class="box-description text-left" v-if="body">
                    {{ body }}
                </p>
            </div>
            <a v-if="button && !hide_button" :href="button.link"
                class="b-0 text-left parent-arrow-icon btn-secondary mb-2 w-full sm:w-auto sm:mb-0 btn sm:text-left px-0">
                <span v-if="button.title">{{ button.title }}</span>
                <Icon class="arrow-icon" v-if="button.icon" :name="button.icon" />
            </a>
        </div>
    </div>
</template>

<script lang="ts">
import { type PropType } from 'vue';
import type { IHeroButton } from './Hero.vue';
import { isDev } from '~/services/common';
import { capture } from '~/services/analytics';

export default {
    props: {
        image_url: String,
        image_40: Boolean,
        icon: String,
        title: String,
        body: String,
        category: String || '',
        total: String,
        button: Object as PropType<IHeroButton>,
        posthog_view_event: String,
        posthog_view_properties: Object,
        max_height_body: String,
        hide_button: Boolean,
        three_col: Boolean
    },
    methods: {
        click(posthog_click_event?: string, posthog_click_properties?: any) {
            if (isDev()) {
                return;
            }

            if (posthog_click_event) {
                capture(posthog_click_event, posthog_click_properties);
            }
        },
    },
    mounted() {
        if (this.posthog_view_event) {
            capture(this.posthog_view_event, this.posthog_view_properties);
        }
    },
};
</script>